import common from "../common";
import Scene from "./Scene";
import Fighter from "../game/Fighter";
import ShockWave from "../game/ShockWave";
import Projectile from "../game/Projectile";
import HealthBar from "../game/HealthBar";
import PowerUp from "../game/PowerUp";
import Button from "../ui/Button";
import Text from "../ui/Text";
import isMobile from "ismobilejs";

export default class GameScene extends Scene {
    constructor(characterData, enemyData)
    {
        super('GameScene');

        this.characterData = characterData;
        this.enemyData = enemyData;

        this.players = [];
        this.enemies = [];
        this.fighters = [];
        this.projectiles = [];
        this.shockWaves = [];
        this.powerups = [];
        this.healthBars = [];

        this.projectileUnderLayer = null;
        this.projectileOverLayer = null;

        this.virtualStick = null;

        this.projectilePool = null;
        this.shockWavePool = null;

        this.leftField = {direction:1};
        this.rightField = {direction:-1};

        this.accumulatedTime = 0;
        this.timerText = null;
        this.startDelay = 2;
        this.endDelay = 4;

        this.powerupInterval = 8;
        this.lastPowerupTime = 0;

        this.started = false;
        this.completed = false;
        this.completionTime = 0;
        this.ended = false;

        this.winner = null;

        this.paused = false;

        this.announcementText = null;

        this.shakeTime = {max:0, current:0};

        //this.projectileMapper = null;
    }

    init()
    {
        super.init('bg_gameplay');

        var particle = new PIXI.particles.Emitter(this.bg, [P3.assets.texture('flour_00'), P3.assets.texture('flour_01'), P3.assets.texture('flour_02')], P3.assets.json('particle_steam_emitter'));
        particle.emit = true;
        particle.updateOwnerPos(common.STAGE_HALF_WIDTH - 450, common.STAGE_HALF_HEIGHT - 200);
        this.particles.push(particle);

        if(window.location.href.search('localhost') > -1)
            this.bg.alpha = 0.5;

        this.setFieldSizes();

        //this.projectileMapper = new PIXI.Graphics();
        //this.addChild(this.projectileMapper);

        var fullHealthBar = common.display.sprite({asset:'panel_life', x:common.STAGE_HALF_WIDTH, y:70, anchor:0.5, parent:this});

        var playerHealth = new HealthBar(0, common.config.settings.gamePhysics.fighters.baseHealth * this.characterData.stamina, common.currentScores[0], -1, parseInt(this.characterData.colour, 16));
        playerHealth.signals.depleted.add(this.onHealthBarDepleted, this);
        playerHealth.x = -55;
        playerHealth.y = -20;
        this.healthBars.push(playerHealth);
        fullHealthBar.addChild(playerHealth);

        var enemyHealth = new HealthBar(1, common.config.settings.gamePhysics.fighters.baseHealth * this.characterData.stamina, common.currentScores[1], 1, parseInt(this.enemyData.colour, 16));
        enemyHealth.signals.depleted.add(this.onHealthBarDepleted, this);
        enemyHealth.x = 55;
        enemyHealth.y = -20;
        this.healthBars.push(enemyHealth);
        fullHealthBar.addChild(enemyHealth);

        var timerHolder = common.display.sprite({asset:'panel_timer', anchor:0.5, parent:fullHealthBar});
        this.timerText = new Text(String(common.config.settings.gameFlow.roundTime), {
            font: 60 + "px Lalezar56",
            align: "center"
        });
        this.timerText.y = -15;
        this.timerText.anchor.set(0.5, 0.5);
        timerHolder.addChild(this.timerText);

        var controlMethod = Fighter.CONTROL_KEYS;

        if(isMobile(window.navigator).any)
        {
            controlMethod = Fighter.CONTROL_VIRTUAL_STICK;

            this.virtualStick = {
                base: common.display.sprite({asset:'btn_move_area', anchor:0.5})
            };
            this.virtualStick.stick = common.display.sprite({asset:'btn_move_out', anchor:0.5, parent:this.virtualStick.base});
            this.virtualStick.base.x = common.STAGE_HALF_WIDTH - (P3.View.width/2) + (this.virtualStick.base.width/2) + 20;
            this.virtualStick.base.y = common.STAGE_HEIGHT - (this.virtualStick.base.height/2) - 20;
            this.virtualStick.base.radius = this.virtualStick.base.width / 2;
            this.virtualStick.stick.radius = this.virtualStick.stick.width / 2;

            this.buttons.fire = new Button(new P3.ButtonStates(
                P3.assets.texture('btn_primary_large_out'),
                P3.assets.texture('btn_primary_large_over'),
                P3.assets.texture('btn_primary_large_down'),
                P3.assets.texture('icon_splat')
            ));
            this.buttons.fire.id = 'fire';
            this.buttons.fire.y = common.STAGE_HEIGHT - 100;
            this.signalListeners.push(this.buttons.fire.signals.down.add(this.onFireClicked, this));
        }

        this.projectileUnderLayer = common.display.container({parent:this});

        var player = new Fighter(this, 0, this.characterData, controlMethod, this.leftField, playerHealth);
        this.addChild(player);

        this.players.push(player);
        this.fighters.push(player);

        var enemy = new Fighter(this, 1, this.enemyData, Fighter.CONTROL_AI, this.rightField, enemyHealth);
        this.addChild(enemy);

        this.enemies.push(enemy);
        this.fighters.push(enemy);

        for(var i in this.fighters)
        {
            this.signalListeners.push(this.fighters[i].signals.fireWeapon.add(this.fireProjectiles, this));
        }

        this.projectilePool = new P3.utils.ObjectPool(Projectile, 10);
        this.shockWavePool = new P3.utils.ObjectPool(ShockWave, 4);

        //common.display.rectangle({rectWidth:this.leftField.width, rectHeight:this.leftField.height, x:this.leftField.x, y:this.leftField.y, lineColour:0xFFFFFF, lineWidth:1, parent:this});
        //common.display.rectangle({rectWidth:this.rightField.width, rectHeight:this.rightField.height, x:this.rightField.x, y:this.rightField.y, lineColour:0xFFFFFF, lineWidth:1, parent:this});

        common.display.sprite({asset:'middle_tables', anchorY:1, anchorX:0.35, scale:0.8, x:common.STAGE_HALF_WIDTH, y:common.STAGE_HEIGHT - 50, parent:this});

        this.projectileOverLayer = common.display.container({parent:this});

        this.announcementText = new Text(common.text.translate('round' + String(common.currentRound+1)), {
            font: 60 + "px Lalezar48",
            align: "center"/*,
            tint: 0x000000*/
        });
        this.announcementText.x = common.STAGE_HALF_WIDTH;
        this.announcementText.y = common.STAGE_HALF_HEIGHT - 200;
        this.announcementText.anchor.set(0.5);
        this.addChild(this.announcementText);

        this.buttons.pause = new Button(new P3.ButtonStates(
            P3.assets.texture('btn_primary_medium_out'),
            P3.assets.texture('btn_primary_medium_over'),
            P3.assets.texture('btn_primary_medium_out'),
            P3.assets.texture('icon_pause')
        ));
        this.buttons.pause.id = 'pause';
        this.buttons.pause.y = 50;
        this.signalListeners.push(this.buttons.pause.signals.click.add(this.onPauseClicked, this));
        this.addChild(this.buttons.pause);
        
        if(this.virtualStick)
        {
            this.addChild(this.virtualStick.base);
        }
        if(this.buttons.fire)
        {
            this.addChild(this.buttons.fire);
        }

        common.audio.playSound('music_fight_loop', this.audioLoopParams);
        common.audio.playSound('sfx_crowd_chatter_mix_loop', this.audioLoopParams);
    }

    destroy()
    {
        super.destroy();

        common.audio.stopSound('music_fight_loop');
        common.audio.stopSound('sfx_crowd_chatter_mix_loop');

        for(var i in this.powerups)
        {
            this.powerups[i].destroy();
        }
    }

    update()
    {
        super.update();

        this.accumulatedTime += P3.Ticker.dt * common.timeStretch;

        if(this.accumulatedTime > this.startDelay && !this.started)
        {
            this.started = true;
            for(var i in this.fighters)
            {
                this.fighters[i].activate();
            }
            this.announcementText.text = common.text.translate('fight');
            P3.utils.delay(1, () => {
                this.announcementText.text = '';
            });
        }

        for(let i in this.fighters)
        {
            this.fighters[i].update();

            for(let j = this.powerups.length-1; j >= 0; j--)
            {
                if(this.powerups[j].active && this.collideAABB(this.fighters[i].bounds, this.powerups[j].hitBox, this.fighters[i], this.powerups[j]))
                {
                    this.powerups[j].collect(
                        this.fighters[i].x + this.fighters[i].bounds.centerX, 
                        this.fighters[i].y + this.fighters[i].bounds.centerY,
                        () => {
                            common.audio.playSound('sfx_take_powerup_00');
                            this.fighters[i].addWeapon(this.powerups[j].type);
                            this.removeChild(this.powerups[j]);
                            this.powerups[j].destroy();
                            this.powerups.splice(j, 1);
                        }
                    );
                    
                }
            }
        }
        for(var i = this.projectiles.length-1; i >= 0; i--)
        {
            var p = this.projectiles[i];

            if(p.canRemove)
            {
                this.projectilePool.free(p);
                this.projectiles.splice(i, 1);
                continue;
            }

            p.update();

            var groundLevel = p.groundLevel;

            //If projectile is between the two fields (over the tables)
            if(p.x > this.leftField.x + this.leftField.width && p.x < this.rightField.x)
            {
                groundLevel -= common.config.settings.gamePhysics.field.tableHeight;
                if(p.weight > 0)
                {
                    p.shadow.y = groundLevel;
                    this.projectileOverLayer.addChild(p.shadow);

                    if(p.y > groundLevel && p.bounceOffWalls)
                    {
                        if((p.speed.x < 0 && p.originFighter.id == 0) ||
                           (p.speed.x > 0 && p.originFighter.id == 1))
                        {
                            p.speed.x = -p.speed.x;
                            this.onProjectileBounce(p);
                        }
                    }
                }
            }
            else
            {
                this.projectileUnderLayer.addChild(p.shadow);
            }

            if(p.weight > 0 && p.y > groundLevel)
            {
                if(p.bounce > 0)
                {
                    p.bounceUp();
                    this.onProjectileBounce(p);
                }
                else if(p.persistentData)
                {
                    p.setAsPersistent();
                    this.projectileUnderLayer.addChild(p);
                }
                else if(!p.splatting)
                {
                    this.splatProjectile(p);
                }
            }
            else
            {
                for(var j in this.fighters)
                {
                    var f = this.fighters[j];
                    if(!p.splatting && p.hasLeftOriginFighter)
                    {
                        //Hitting a fighter
                        if(p.x > f.x + f.bounds.x && p.x < f.x + f.bounds.x + f.bounds.width)
                        {
                            if( (p.isPersistent &&
                               p.y > f.y + f.bounds.y + (f.bounds.height/2) && p.y < f.y + f.bounds.y + f.bounds.height)
                                    ||
                                (!p.isPersistent &&
                                p.y > f.y + f.bounds.y && p.y < f.y + f.bounds.y + f.bounds.height)
                               )
                            {
                                if(p.bounceOffFighters)
                                {
                                    p.speed.x = p.speed.x * -1;
                                    this.onProjectileBounce(p);
                                    continue;
                                }
                                if(!this.completed)
                                {
                                    f.hit(p.damage);
                                    if(p.incapacitate && !f.incapacitated)
                                    {
                                        f.incapacitate();
                                    }
                                }
                                this.splatProjectile(p);

                                break;
                            }
                        }
                        
                        //Hitting the back walls
                        if( Math.sign(p.speed.x) != f.field.direction &&
                            (p.xSpeedMod == null || Math.sign(p.xSpeedMod) == Math.sign(p.speed.x)) && 
                            ((p.speed.x > 0 && p.x > f.field.x + f.field.width) ||
                                 (p.speed.x < 0 && p.x < f.field.x)) )
                        {
                            if(p.bounceOffWalls)
                            {
                                p.speed.x = p.speed.x * -1;
                                this.onProjectileBounce(p);
                                continue;
                            }

                            this.splatProjectile(p);

                            break;
                        }

                        if(p.weight == 0 && p.y < f.field.y)
                        {
                            this.splatProjectile(p)
                            //p.splat();
                            break;
                        }
                    }
                }
            }

            /*
            s.x = p.x;
            s.y = p.groundLevel;
            var sper = Math.abs(s.y - p.y) / 500;
            s.alpha = sper;
            s.scale.set(sper);*/
        }
        for(var i = this.shockWaves.length-1; i >= 0; i--)
        {
            if(this.shockWaves[i].update())
            {
                this.shockWavePool.free(this.shockWaves[i]);
                this.shockWaves.splice(i, 1);
            }
            else if(!this.completed)
            {
                for(var j in this.fighters)
                {
                    if(this.shockWaves[i].affectedFighters.indexOf(this.fighters[j].id) < 0)
                    {
                        var range = this.shockWaves[i].getRange(this.fighters[j].x + this.fighters[j].bounds.centerX, this.fighters[j].y + this.fighters[j].bounds.centerY);
                        if(range.damage > 0)
                        {
                            this.fighters[j].hit(range.damage);
                            this.shockWaves[i].affectedFighters.push(this.fighters[j].id);
                        }
                        if(range.incapacitate)
                        {
                            this.fighters[j].incapacitate();
                        }
                    }
                }
            }
        }

        if(this.started && !this.completed && this.accumulatedTime > this.lastPowerupTime + this.powerupInterval)
        {
            if(Math.random() > 0.97)
            {
                this.addPowerup();
                this.lastPowerupTime = this.accumulatedTime;
            }
        }

        if(this.completed && !this.ended && this.accumulatedTime - this.completionTime > this.endDelay)
        {
            this.signals.next.dispatch(this.winner, this.healthBars[0].health / this.healthBars[0].maxHealth);
            this.ended = true;
        }

        if(this.started && !this.completed)
        {
            var roundTime = Math.max(0, Math.floor( common.config.settings.gameFlow.roundTime - (this.accumulatedTime - this.startDelay)) );
            this.timerText.text = String(roundTime);
            if(roundTime <= 0)
            {
                this.winner = this.healthBars[0].health < this.healthBars[1].health ? 1 : 0
                this.complete(false);
            }
        }

        if(this.shakeTime.current > 0)
        {
            var d = 1;
            if(this.x > 0)
                d = -1;
                
            this.x = ((P3.View.width - common.STAGE_WIDTH) * 0.5) + (d * (70 * (this.shakeTime.current / this.shakeTime.max))) * Math.random();
            this.shakeTime.current -= P3.Ticker.dt * common.timeStretch;
        }
        else
        {
            this.shakeTime.current = this.shakeTime.max = 0;
            this.x = (P3.View.width - common.STAGE_WIDTH) * 0.5;
        }
    }

    resize()
    {
        super.resize();
        this.setFieldSizes();

        this.buttons.pause.x = common.STAGE_HALF_WIDTH + (P3.View.width/2) - 50;

        if(this.buttons.fire)
        {
            this.buttons.fire.x = common.STAGE_HALF_WIDTH + (P3.View.width/2) - 100;
        }
    }

    fireProjectiles(fighter, pData, p, pImage)
    {
        var randomValue = (arr, integer) => {
            
            if(integer)
            {
                return arr.length > 1 ? P3.math.randomInt(arr[0], arr[1]) : arr[0];
            }
            else
            {
                return arr.length > 1 ? P3.math.random(arr[0], arr[1]) : arr[0];
            }
        };

        var physics = common.config.settings.gamePhysics.projectiles;

        var limit = randomValue(pData.projectileAmount, true)

        var pOrder = 0;

        for(var i = 0; i < limit; i++)
        {
            if(p == null)
                p = pData.projectiles[pOrder];
                //p = pData.projectiles[Math.floor(Math.random() * pData.projectiles.length)];

            pOrder++;
            if(pOrder >= pData.projectiles.length)
                pOrder = 0;

            if(this.projectilePool.available === 0)
                this.projectilePool.expand(1);

            var speedX = null;
            var speedY = null;
            var setRotation = p.setRotation;

            if(typeof p.aimAtFighter == 'number')
            {
                var targetFighter = null;
                if(fighter.id == 0)
                    targetFighter = this.enemies[0];
                else
                    targetFighter = this.players[0];

                var angle = Math.atan2(targetFighter.y - fighter.y, targetFighter.x - fighter.x);
                if(angle < 0) angle = (2*Math.PI) + angle;
                if(typeof setRotation == 'number')
                {
                    setRotation += angle * PIXI.RAD_TO_DEG;
                }
                
                speedY = (physics.baseSpeed.x * (Math.sin(angle) * p.aimAtFighter)) * fighter.attributes.range;
                speedX = (physics.baseSpeed.x * (Math.cos(angle) * p.aimAtFighter)) * fighter.attributes.range;
            }
            else
            {
                speedX = ((physics.baseSpeed.x * randomValue(p.xSpeed)) * fighter.attributes.range) * fighter.field.direction;
                speedY = (physics.baseSpeed.y * randomValue(p.ySpeed)) * fighter.attributes.range;
            }
            
            var projectile = this.projectilePool.create();
            projectile.init(
                fighter,
                common.config.weapons.images[pImage] || (p.images.length > 0 ? common.config.weapons.images[p.images[Math.floor(Math.random() * p.images.length)]] : null),
                fighter.x + fighter.projectileOffset.x,
                fighter.y + fighter.projectileOffset.y, 
                speedX,
                speedY,
                physics.gravity * randomValue(p.weight),
                (physics.baseDamage * randomValue(p.damage)) * fighter.characterData.power,
                fighter.y,
                p.bounce,
                p.bounceOffWalls || false,
                p.bounceOffFighters || false,
                p.persistent,
                p.incapacitate,
                p.shockRadius,
                p.particles,
                (typeof setRotation == 'number' ? setRotation : null),
                (typeof p.xSpeedMod == 'number' ? ((p.xSpeedMod * fighter.field.direction) * physics.baseSpeed.x) : null),
                p.flashTint,
                p.shake,
                this.projectileUnderLayer,
                p.audio
            );
            this.projectiles.push(projectile);
            this.addChild(projectile);

            if(projectile.particle && projectile.particle.inAir)
            {
                projectile.inAirParticle = this.addParticle(projectile.particle.inAir, projectile.x, projectile.y); 
            }

            var sounds = ['sfx_throw_light_00', 'sfx_throw_light_01', 'sfx_throw_light_02'];
            if(p.weight == 0)
                sounds = ['sfx_throw_mid_00'];
            else if(p.weight < 0.3)
                sounds = ['sfx_throw_v_light_00', 'sfx_throw_v_light_01'];
            else if(p.weight > 0.9)
                sounds = ['sfx_throw_heavy_00'];
            else if(p.weight > 0.7)
                sounds = ['sfx_throw_mid_00'];

            common.audio.playSound(sounds);

            p = null;
            pImage = null;

            /*
            this.projectileMapper.beginFill(0xFFFFFF);
            for(var i in projectile.trajectory)
            {
                this.projectileMapper.drawCircle(projectile.trajectory[i].x, projectile.trajectory[i].y, 3);
            }
            this.projectileMapper.endFill();*/
        }
    }

    addPowerup()
    {
        var targetY = null;
        var acceptable = false;
        var count = 0;

        while(!acceptable && count < 10)
        {
            targetY = (this.leftField.y + 50) + (Math.random() * (this.leftField.height-100));
            acceptable = true;
            for(var i in this.powerups)
            {
                if(this.powerups[i].targetY != null && Math.abs(targetY - this.powerups[i].targetY) < this.powerups[i].boxSize)
                {
                    acceptable = false;
                    break;
                }
            }
            count++;
        }

        if(acceptable)
        {
            var types = [];
            for(var i in common.config.weapons.weapons)
            {
                if(common.config.weapons.weapons[i].powerUp && 
                   (common.config.settings.gamePhysics.powerUp.limitedTo.length == 0 ||
                    common.config.settings.gamePhysics.powerUp.limitedTo.indexOf(i) > -1))
                {
                    types.push(i);
                }
            }

            var powerup = new PowerUp(types[Math.floor(Math.random() * types.length)]);
            this.addChild(powerup);
            powerup.throwIn(common.STAGE_HALF_WIDTH, targetY, () => 
            {
                for(var i in this.fighters)
                {
                    if(this.fighters[i].controlMethod === Fighter.CONTROL_AI)
                    {
                        var pos = {x:common.STAGE_HALF_WIDTH + ((this.fighters[i].bounds.x/2) * this.fighters[i].field.direction), y:targetY - this.fighters[i].bounds.centerY};
                        this.fighters[i].control.powerupRoute(pos.x, pos.y, powerup);
                    }
                }

                var powerupText = new Text(common.text.translate('powerUp'), {
                    font: 35 + "px Lalezar48",
                    align: "center"
                });
                powerupText.x = powerup.x
                powerupText.y = powerup.y;
                powerupText.anchor.set(0.5, 0.5);
                this.addChild(powerupText);

                powerupText.scale.set(0);
                TweenMax.to(powerupText.scale, .3, {x:1.2, y:1.2, ease:Back.easeOut, onComplete:() => {
                    TweenMax.to(powerupText.scale, .7, {x:1, y:1, ease:Elastic.easeOut});
                }});
                TweenMax.to(powerupText, 2, {y:powerup.y - 150, ease:Sine.easeIn});
                TweenMax.to(powerupText, .3, {delay:1.7, alpha:0, onComplete:() => {
                    this.removeChild(powerupText);
                }});

                var burst = new PIXI.particles.Emitter(this, [P3.assets.texture('sparkle_00')], P3.assets.json('particle_result_star_appear'));
                burst.emit = true;
                burst.updateOwnerPos(powerup.x, powerup.y);
                this.particles.push(burst);

                var attract = new PIXI.particles.Emitter(this, [P3.assets.texture('sparkle_00')], P3.assets.json('particle_powerup_attract'));
                attract.emit = true;
                attract.updateOwnerPos(powerup.x, powerup.y);
                this.particles.push(attract);
                powerup.particle = attract;
            });
            this.powerups.push(powerup);
        }
    }

    complete(ko)
    {
        if(this.completed)
            return;

        common.audio.stopSound('music_fight_loop');

        this.completed = true;
        this.completionTime = this.accumulatedTime;

        this.fighters[1-this.winner].deactivate();

        common.currentScores[this.winner]++;

        for(var i = 0; i < this.healthBars.length; i++)
        {
            this.healthBars[i].setVictories(common.currentScores[i]);
        }

        this.fighters[1-this.winner].lose(ko);

        var perfect = this.healthBars[0].health == this.healthBars[0].maxHealth;
        if(perfect)
            this.endDelay = 7;

        var completeText = () => 
        {
            if(common.currentScores[this.winner] == common.config.settings.gameFlow.rounds)
            {
                common.audio.playSound('sfx_fight_end_school_bell');
            }

            this.fighters[this.winner].win(ko);
            this.fighters[this.winner].deactivate();
            this.announcementText.text = common.text.translate(this.winner == 0 ? 'youWin' : 'youLose');
            this.announcementText.scale.set(0);
            TweenMax.to(this.announcementText.scale, 0.3, {x:1, y:1, ease:Expo.easeOut});
            if(perfect)
            {
                P3.utils.delay(2, () => {
                    this.announcementText.text = common.text.translate('perfect');
                    var tl = new TimelineMax();
                    tl.to(this.announcementText.scale, .3, {x:1.5, y:1.5, ease:Expo.easeOut});
                    tl.to(this.announcementText.scale, 1, {x:1, y:1, ease:Elastic.easeOut});
                    var burst = new PIXI.particles.Emitter(this, [P3.assets.texture('sparkle_00')], P3.assets.json('particle_result_star_appear'));
                    burst.emit = true;
                    burst.updateOwnerPos(this.announcementText.x, this.announcementText.y);
                    this.particles.push(burst);
                });
            }
        };

        if(ko)
        {
            common.audio.playSound(['sfx_crowd_laughter_00', 'sfx_crowd_laughter_01', 'sfx_crowd_laughter_02', 'sfx_crowd_laughter_03', 'sfx_crowd_laughter_04', 'sfx_crowd_laughter_05', 'sfx_crowd_laughter_06', 'sfx_crowd_laughter_07', 'sfx_crowd_laughter_08']);

            var slowdown = {time:1};
            var tl = new TimelineMax({
                onUpdate:() => {
                    common.timeStretch = slowdown.time;
                }, 
                onComplete:() => {
                    completeText();
                }
            });
            tl.to(slowdown, 0.2, {time:0.2});
            tl.to(slowdown, 1.5, {delay:1.5, time:1});
            this.shakeScene(0.2);

            var koText = new Text(common.text.translate('ko'), {
                font: 100 + "px Lalezar48",
                align: "center"
            });
            koText.x = common.STAGE_HALF_WIDTH;
            koText.y = -500;
            koText.anchor.set(0.5, 0.5);
            this.addChild(koText);

            TweenMax.to(koText, 0.7, {y:common.STAGE_HALF_HEIGHT, ease:Expo.easeOut});
        }
        else
        {
            completeText();
        }

        if(this.winner == 0)
        {
            common.audio.playSound('music_splash_press_play_sting');
        }
        else
        {
            common.audio.playSound('music_you_lose_sting');
        }
    }

    splatProjectile(p)
    {
        p.splat();
        if(p.shockRadius > 0)
        {
            this.addShockWave(p.shockRadius, p.damage, p.x, p.y, p.incapacitate);
        }
        if(p.particle && p.particle.onSplat)
        {
            this.addParticle(p.particle.onSplat, p.x, p.y);
        }
        if(p.shake)
        {
            this.shakeScene(p.shake);
        }
        if(p.audio && p.audio.onSplat)
        {
            if(typeof p.audio.onSplat == 'string')
            {
                common.audio.playSound(common.config.weapons.sounds[p.audio.onSplat]);
            }
            else
            {
                common.audio.playSound(p.audio.onSplat);
            }
        }
    }

    addShockWave(radius, damage, x, y, incapacitate)
    {
        if(this.shockWavePool.available === 0)
            this.shockWavePool.expand(1);

        var shockWave = this.shockWavePool.create();
        shockWave.init(radius, damage, incapacitate);
        shockWave.x = x;
        shockWave.y = y;
        this.addChild(shockWave);
        this.shockWaves.push(shockWave);
    }

    addParticle(particle, x, y)
    {
        var imageAssets = [];

        for(var i in particle.images)
        {
            imageAssets[i] = P3.assets.texture(particle.images[i]);
        }

        var particle = new PIXI.particles.Emitter(this, imageAssets, P3.assets.json(particle.json));
        particle.emit = true;
        particle.updateOwnerPos(x, y);
        this.particles.push(particle);

        return particle;
    }

    onProjectileBounce(p)
    {
        if(p.audio && p.audio.onBounce)
        {
            if(typeof p.audio.onBounce == 'string')
            {
                common.audio.playSound(common.config.weapons.sounds[p.audio.onBounce]);
            }
            else
            {
                common.audio.playSound(p.audio.onBounce);
            }
        }
    }

    shakeScene(time)
    {
        this.shakeTime.max = this.shakeTime.current = time;
    }

    setFieldSizes()
    {
        var fieldDef = common.config.settings.gamePhysics.field;
        var width = Math.min(P3.View.width/2, fieldDef.width) - fieldDef.gap;

        this.leftField.x = common.STAGE_HALF_WIDTH - width - fieldDef.gap;
        this.leftField.y = fieldDef.top;
        this.leftField.height = common.STAGE_HEIGHT - fieldDef.top - fieldDef.bottom;
        this.leftField.width = width;

        this.rightField.x = common.STAGE_HALF_WIDTH + fieldDef.gap;
        this.rightField.y = fieldDef.top;
        this.rightField.height = common.STAGE_HEIGHT - fieldDef.top - fieldDef.bottom;
        this.rightField.width = width;

        this.leftField.tableHeight = this.rightField.tableHeight = fieldDef.tableHeight;
    }

    collideAABB(r1B, r2B, r1 = {x:0, y:0}, r2 = {x:0, y:0})
    {
        return !(r2.x + r2B.x > (r1.x + r1B.x + r1B.width) ||
        (r2.x + r2B.x + r2B.width) < r1.x + r1B.x ||
        r2.y + r2B.y > (r1.y + r1B.y + r1B.height) ||
        (r2.y + r2B.y + r2B.height) < r1.y + r1B.y);
    }

    onPause()
    {
        this.paused = true;
        this.buttons.pause.disappear();
        common.audio.pauseSound('music_fight_loop');
    }

    onResume()
    {
        this.paused = false;
        this.buttons.pause.appear();
        common.audio.resumeSound('music_fight_loop');
    }

    onHealthBarDepleted(id)
    {
        this.winner = 1-id;
        this.complete(true);
    }

    onPauseClicked()
    {
        if(!this.paused)
            this.signals.pause.dispatch();
    }

    onFireClicked()
    {
        for(var i in this.players)
        {
            this.players[i].fire();
        }
    }
}